<template>
  <div class="modal fade" ref="genericModal" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" ref="modalContent">

        <div v-if="this.$slots.header" class="modal-header">
          <slot name="header"></slot>
          <!-- X button for closing dialog -->
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="x-button-clicked"></button>
        </div>

        <div class="modal-body">
          <slot></slot>
        </div>

        <div v-if="this.$slots.footer" class="modal-footer">
          <slot name="footer"></slot>
        </div>

      </div>

    </div>
  </div>

</template>

<script>
import {Modal} from "bootstrap";

export default {
  name: "GenericModal",
  emits: ['modal-closed', 'x-button-clicked'],
  props: ['backgroundColor'],
  data() {
    return {
      bootstrapModal: null,
      unmounting: false
    }
  },
  mounted() {
    //console.log('GenericModal : mounted()');
    this.$refs.genericModal.addEventListener('hidden.bs.modal', this.onModalHidden);
    this.$refs.genericModal.addEventListener('shown.bs.modal', this.onModalShown);

    if ( this.backgroundColor ) {
      this.$refs.modalContent.style.backgroundColor = this.backgroundColor;
    }

    this.bootstrapModal = new Modal(this.$refs.genericModal, {});
    this.bootstrapModal.show();
  },
  beforeUnmount() {
    //console.log('GenericModal : beforeUnmount()');
    this.unmounting = true;
    this.bootstrapModal.hide();
  },

  methods: {
    onModalShown() {
      //console.log('GenericModal : onModalShown()');

      // in the rare but possible event that a modal is unmounted before it's fully shown, immediately hide it.
      if ( this.unmounting ) {
        this.bootstrapModal.hide();
      }
    },
    closeModal() {
      //console.log('GenericModal : closeModal()');
      this.bootstrapModal.hide();
    },
    onModalHidden() {
      //console.log('GenericModal : onModalHidden()');
      this.$emit('modal-closed', null);
    },
  }
}
</script>

<style scoped>

  .modal-dialog {
    top: env(safe-area-inset-top);
    line-height: var(--bs-body-line-height);
    font-size: var(--bs-body-font-size);
    min-width: min(var(--bs-modal-width), calc(100vw - (var(--bs-modal-margin) * 2)));


    .modal-body {
      font-size: small;
    }
  }

</style>